import React from 'react';

// GraphQl
import { useQuery } from '@apollo/react-hooks';

// Components & Others
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import LoadingIndicator from '../../../LoadingIndicator';
import CurrencyForm from '../CurrencyForm';
import { GET_CURRENCY } from '../queries';

function CurrencyEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_CURRENCY, {
    variables: { id },
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    console.error('get currency', error);
    history.goBack();
  }

  const formatValue = { ...data.currency };
  if (!data.currency) {
    history.goBack();
  }

  return <CurrencyForm currency={formatValue} id={id} isEdit />;
}

CurrencyEdit.propTypes = {};

export default CurrencyEdit;
